export const NODE_ENV = process.env.NODE_ENV;
export const ASSERT_MANAGEMENT_API_ENDPOINT =
  process.env.ASSERT_MANAGEMENT_API_ENDPOINT;
export const ADD_QUESTIONS_API_ENDPOINT = `${process.env.ASSERT_MANAGEMENT_API_ENDPOINT}/ABC`;
export const REACT_APP_AUTHENTICATE_TOKEN_NAME =
  process.env.REACT_APP_AUTHENTICATE_TOKEN_NAME;
export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
export const REACT_APP_TENANT_ID = process.env.REACT_APP_TENANT_ID;
export const CMS_API_ENDPOINT = process.env.CMS_API_ENDPOINT;
export const ASSET_MANAGEMENT_ENDPOINT = process.env.ASSET_MANAGEMENT_ENDPOINT;
export const REACT_APP_LOGIN_GATEWAY_API_ENDPOINT =
  process.env.REACT_APP_LOGIN_GATEWAY_API_ENDPOINT;
export const UAM_API_ENDPOINT = process.env.UAM_API_ENDPOINT;
export const SIDEBAR_DRAWER_WIDTH = 240;
export const ISD_CODE = "+90";

export const TENANT_ID = "1";

export const PRODUCT_ID = "300";

export const CREATE_PACKAGE_SCRIPT_ID = 5;

export const CREATE_PRODUCT_OFFERINGS_SCRIPT_ID = 8;

export const UPLOAD_FEATURE_OFFERINGS_TO_PACKAGES_SCRIPT_ID = 6

export const CURRENCY_ID = 1;

export const ADMIN_SUPPORT_MODULE_ID = 3;

export const UPLOAD_PACKAGE_SCHEDULE_SCRIPT_ID = 9;

export const UPDATE_PACKAGE_SCHEDULE_SCRIPT_ID = 11;

export const FILE_UPLOAD_STATUS = {
  CREATED: 1,
  UPLOADED: 2,
  PROCESSED: 3,
};
